import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_NEW_PROJECTS_REQUEST, fetchNewProjectFailure, fetchNewProjectSuccess } from "../actions/newProjectsActions";
import { fetchNewProjects } from "../../../services/accIqService";

// Worker Saga
function* FetchNewProjectSaga() {
  try {
    const payload = yield select(state=>state?.newProjectsReducer?.payload);
    const data = yield call(fetchNewProjects,payload);

    yield put(fetchNewProjectSuccess(data));
  } catch (error) {
    yield put(fetchNewProjectFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchNewProject() {
  yield takeLatest(FETCH_NEW_PROJECTS_REQUEST, FetchNewProjectSaga);
}
